import { apiGet, apiPut } from "./http";
import type { ContributionCategory, PointsSubjectType } from "../pages/admin/utils/contributionStore";

export interface ContributionCategoryDto {
  categoryKey: string;
  name: string;
  unit: string;
  pointsPerUnit: number;
  description: string;
  subjectType?: string;
  subjectTypeLabel?: string;
  isActive: boolean;
  createdAt: string;
  sortOrder: number;
}

function normalizeSubjectType(raw?: string): PointsSubjectType {
  return String(raw || "").trim().toLowerCase() === "deduct" ? "deduct" : "award";
}

export function dtoToContributionCategory(d: ContributionCategoryDto): ContributionCategory {
  return {
    id: d.categoryKey,
    name: d.name,
    unit: d.unit,
    pointsPerUnit: d.pointsPerUnit,
    description: d.description ?? "",
    subjectType: normalizeSubjectType(d.subjectType),
    isActive: d.isActive,
    createdAt: d.createdAt,
  };
}

export function contributionCategoriesToReplaceBody(items: ContributionCategory[]) {
  return {
    categories: items.map((c, i) => ({
      categoryKey: c.id,
      name: c.name,
      unit: c.unit,
      pointsPerUnit: c.pointsPerUnit,
      description: c.description ?? "",
      subjectType: c.subjectType ?? "award",
      isActive: c.isActive,
      createdAt: c.createdAt,
      sortOrder: i + 1,
    })),
  };
}

export async function fetchContributionCategoriesForTenant(tenantLegacyId: string): Promise<ContributionCategory[]> {
  const rows = await apiGet<ContributionCategoryDto[]>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/contribution-categories`,
  );
  return rows.map(dtoToContributionCategory);
}

export async function putContributionCategoriesForTenant(
  tenantLegacyId: string,
  items: ContributionCategory[],
): Promise<ContributionCategory[]> {
  const rows = await apiPut<ContributionCategoryDto[]>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/contribution-categories`,
    contributionCategoriesToReplaceBody(items),
  );
  return rows.map(dtoToContributionCategory);
}
